/**
 * App-specific theme initializer.
 *
 * Delegates to the centralized initializeTtTheme from tt-branding-app-lib
 * for color + font loading, then applies any extra app-specific logic
 * (TenantService branding overrides, font preset from tenant config).
 */
import { inject } from '@angular/core';
import {
  TtThemeService,
  initializeTtTheme,
  getFontPreset,
  loadGoogleFonts,
} from '@tamilarasitech/tt-branding-app-lib';
import { TenantService } from '../services/tenant.service';

export function initializeTheme() {
  const tenantService = inject(TenantService);
  const themeService = inject(TtThemeService);

  return async () => {
    // 1. Run the library's generic initializer (reads window.__tenantConfig)
    const libInit = initializeTtTheme();
    await libInit();

    // 2. Apply app-specific overrides from TenantService
    const branding = tenantService.getBranding();

    if (branding) {
      // Colors from branding (if not already set by tenant config)
      const tenantConfig = (window as any).__tenantConfig as any;
      const mainColors = tenantConfig?.theme?.mainColors ?? tenantConfig?.theme;

      if (!mainColors?.primaryColor && branding.primaryColor && branding.secondaryColor) {
        themeService.setBrandColors(branding.primaryColor, branding.secondaryColor);
      }

      // Font preset from branding
      if (branding.fontPreset) {
        const preset = getFontPreset(branding.fontPreset);
        if (preset) {
          themeService.setFonts({
            display: preset.display,
            body: preset.body,
            mono: preset.mono,
          });
          if (preset.googleFonts?.length) {
            loadGoogleFonts(preset.googleFonts);
          }
        }
      }
    }
  };
}
